<template>
<div class="chapter">
<div class="inner_page">
<div>
<img alt="cover" src="cover.jpeg" style="height:auto; width: 100%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?727b1678